"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { Copy, Check } from "lucide-react" 
import "../styles/compra.css"

const MapaCategoriaVisual = ({ evento, categoriaSelecionada, modoCompartilhado = false }) => {
  const [diasEvento, setDiasEvento] = useState([])
  const [mapaSenhas, setMapaSenhas] = useState({})
  const [diaAberto, setDiaAberto] = useState(null)
  const [senhasReservadas, setSenhasReservadas] = useState([])
  const [loading, setLoading] = useState(false)
  const [copiado, setCopiado] = useState(false) 

  // 🔹 Carrega os dias da categoria selecionada
  useEffect(() => {
    if (evento?.categorias && categoriaSelecionada) {
      const categoria = evento.categorias.find(
        (cat) => cat.nome === categoriaSelecionada
      )

      if (categoria?.dias) {
        setDiasEvento(categoria.dias)
        setDiaAberto(categoria.dias[0]?.nome || null)
      } else {
        setDiasEvento([])
        setDiaAberto(null)
      }
    }
  }, [evento, categoriaSelecionada])

  // 🔹 Monta o mapa visual com base nos dias
  useEffect(() => {
    if (diasEvento.length > 0) {
      const novoMapa = {}

      diasEvento.forEach((dia) => {
        novoMapa[dia.nome] = Array.from(
          { length: dia.senhaFinal - dia.senhaInicial + 1 },
          (_, i) => ({
            numero: dia.senhaInicial + i,
          })
        )
      })

      setMapaSenhas(novoMapa)
    } else {
      setMapaSenhas({})
    }
  }, [diasEvento])

  // 🔹 BUSCA GLOBAL: senhas bloqueadas do EVENTO (ignora categoria)
  useEffect(() => {
    if (evento?._id) {
      const buscarSenhasBloqueadas = async () => {
        try {
          setLoading(true)
          const response = await axios.get(
            `https://api.ticketdovaqueiro.com/api/pedidos/senhas-reservadas/${evento._id}/${categoriaSelecionada}`
          )
          if (response.status === 200) {
            // 💡 Agora guardamos o array de objetos completo (com numero e nomeVaqueiro)
            setSenhasReservadas(response.data)
          }
        } catch (error) {
          console.error("❌ Erro ao carregar senhas bloqueadas:", error)
        } finally {
          setLoading(false)
        }
      }

      buscarSenhasBloqueadas()
      
      let interval;
      if (modoCompartilhado) {
        // Atualiza o mapa automaticamente a cada 10 segundos no link compartilhado
        interval = setInterval(buscarSenhasBloqueadas, 10000);
      }
      return () => clearInterval(interval);
    }
  }, [evento, modoCompartilhado])

  // 🔹 Função para Copiar o Link
  const handleCopiarLink = () => {
    const url = `${window.location.origin}/mapa-compartilhado/${evento._id}/${encodeURIComponent(categoriaSelecionada)}`;
    navigator.clipboard.writeText(url);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  }

  return (
    <div className="mapa-container">
      
      {/* 💡 CABEÇALHO DO MODAL (Oculto no modo compartilhado) */}
      {!modoCompartilhado && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "15px", paddingBottom: "10px", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
          <h2 className="titulo-mapa59" style={{ margin: 0, fontSize: "18px", color: "#fff", flex: "1 1 auto" }}>
            Mapa: <span style={{color: "var(--primary)"}}>{categoriaSelecionada}</span>
          </h2>
          
          <button 
            onClick={handleCopiarLink}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", color: copiado ? "#10b981" : "#fff", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600", transition: "0.2s", whiteSpace: "nowrap" }}
          >
            {copiado ? <><Check size={16} /> Copiado!</> : <><Copy size={16} /> Compartilhar Mapa</>}
          </button>
        </div>
      )}

      {/* 💡 CABEÇALHO DO COMPARTILHAMENTO (Com Legenda Gigante) */}
      {modoCompartilhado && (
        <div style={{ textAlign: "center", marginBottom: "20px", background: "rgba(0,0,0,0.3)", padding: "15px", borderRadius: "8px", border: "1px solid rgba(255,255,255,0.05)" }}>
           <h2 style={{ fontSize: "20px", color: "var(--primary)", margin: "0 0 5px 0" }}>{evento?.nome}</h2>
           <h3 style={{ fontSize: "16px", color: "#fff", margin: 0 }}>Categoria: {categoriaSelecionada}</h3>
           
           {/* NOVA LEGENDA DESTACADA PARA O MODO COMPARTILHADO */}
           <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "15px", marginBottom: "5px", fontSize: "14px", color: "rgba(255,255,255,0.9)", flexWrap: "wrap", background: "rgba(255,255,255,0.05)", padding: "8px", borderRadius: "6px", border: "1px solid rgba(255,255,255,0.1)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ width: "16px", height: "16px", background: "#10b981", borderRadius: "4px", boxShadow: "0 0 5px rgba(16,185,129,0.5)" }}></div>
                  <span style={{ fontWeight: "bold" }}>Livre</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div style={{ width: "16px", height: "16px", background: "#ef4444", borderRadius: "4px", boxShadow: "0 0 5px rgba(239,68,68,0.5)" }}></div>
                  <span style={{ fontWeight: "bold" }}>Vendidos</span>
              </div>
           </div>

           <span style={{ fontSize: "11px", color: "#888", display: "block", marginTop: "12px" }}>🔴 Atualização Automática em Tempo Real</span>
        </div>
      )}

      <div className="tabs-dias">
        {diasEvento.map((dia) => (
          <button
            key={dia.nome}
            onClick={() => setDiaAberto(dia.nome)}
            className={`tab-dia ${dia.nome === diaAberto ? "ativo" : ""}`}
          >
            {dia.nome}
          </button>
        ))}
      </div>

      {/* 💡 LEGENDA NORMAL (Para o Modal de Compra do Site) */}
      {!modoCompartilhado && (
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "15px", marginTop: "-5px", fontSize: "12px", color: "rgba(255,255,255,0.7)", flexWrap: "wrap" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <div style={{ width: "12px", height: "12px", background: "#10b981", borderRadius: "3px" }}></div>
                  <span>Livre</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <div style={{ width: "12px", height: "12px", background: "#ef4444", borderRadius: "3px" }}></div>
                  <span>Vendidos</span>
              </div>
          </div>
      )}

      <div className="mapa-senhas">
        {diaAberto &&
          mapaSenhas[diaAberto]?.map((senha, index) => {
            
            // 💡 BUSCA CORRETA DO OBJETO E DO NOME DO VAQUEIRO
            let estaReservada = false;
            let nomeVaqueiro = "Vaqueiro não informado";

            // Esse 'find' inteligente suporta tanto se a API mandar objeto {numero: 10, nomeVaqueiro: 'João'} ou só o número 10
            const reservaInfo = senhasReservadas.find(r => 
                (typeof r === "object" && Number(r.numero) === Number(senha.numero)) ||
                (typeof r === "number" && r === Number(senha.numero))
            );

            if (reservaInfo) {
                estaReservada = true;
                if (typeof reservaInfo === "object" && reservaInfo.nomeVaqueiro) {
                    nomeVaqueiro = reservaInfo.nomeVaqueiro;
                }
            }

            return (
              <div
                key={index}
                className={`senha-bloco ${estaReservada ? "reservada" : "disponivel"} visual-only`}
                
                // 💻 TOOLTIP PARA PC: Mostra o nome ao parar o mouse em cima
                title={estaReservada ? `Reservada por: ${nomeVaqueiro}` : "Livre"}
                
                // 📱 ALERTA PARA CELULAR: Mostra o nome ao tocar no quadradinho vermelho
                onClick={() => {
                  if (estaReservada) {
                    alert(`🐴 Senha ${senha.numero} reservada por:\n${nomeVaqueiro}`);
                  }
                }}

                // 💡 A MÁGICA ESTÁ AQUI: pointerEvents furando o bloqueio do CSS
                style={{ 
                  cursor: estaReservada ? "pointer" : "default",
                  pointerEvents: "auto" 
                }}
              >
                {senha.numero}
              </div>
            )
          })}
      </div>

      {loading && <p className="loading-text">Carregando mapa...</p>}
    </div>
  )
}

export default MapaCategoriaVisual